export default "/_next/static/images/05fa005532c200148431b3dd575d8897.jpg";